export enum PspCodesEnum {
    Apcopay = "Apcopay",
    Nuvei = "Nuvei",
    Revolut = "Revolut",
    EMP = "EMP",
    NoPSP = "NOPSP"
}